export class ChatCreate {
  static readonly type = '@ChatState.create';
  constructor(public payload: { message: string }) {}
}

export class ChatGetAll {
  static readonly type = '@ChatState.getAll';
}

export class ChatDelete {
  static readonly type = '@ChatState.deleteChat';
  constructor(public chatId: string) {}
}
